import { HStack, StackProps } from "@chakra-ui/react";

export const TableBoxHeader: React.FC<StackProps> = ({ children, ...rest }) => (
  <HStack
    className="mb-tablebox-header"
    alignItems="stretch"
    minHeight="var(--mb-tablebox-header-height)"
    px="24px"
    data-ls-enabled={true}
    data-public={true}
    {...rest}
  >
    {children}
  </HStack>
);
